var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStarFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77404 19.4843L4.53904 29.1623C4.46983 29.4553 4.49061 29.7624 4.59866 30.0435C4.7067 30.3246 4.897 30.5665 5.14469 30.7377C5.39239 30.909 5.68596 31.0015 5.98707 31.0033C6.28818 31.0051 6.58283 30.916 6.83254 30.7478L15 25.3028L23.1675 30.7478C23.423 30.9174 23.7244 31.0047 24.031 30.998C24.3376 30.9913 24.6348 30.8908 24.8826 30.7101C25.1304 30.5295 25.317 30.2772 25.4172 29.9874C25.5174 29.6975 25.5264 29.3839 25.443 29.0888L22.6995 19.4888L29.5035 13.3658C29.7215 13.1695 29.8771 12.9138 29.9512 12.63C30.0253 12.3463 30.0145 12.0471 29.9204 11.7694C29.8262 11.4917 29.6527 11.2476 29.4213 11.0675C29.19 10.8873 28.9109 10.779 28.6185 10.7558L20.067 10.0748L16.3665 1.88326C16.2485 1.61949 16.0567 1.39551 15.8143 1.23835C15.5718 1.08119 15.289 0.997559 15 0.997559C14.7111 0.997559 14.4283 1.08119 14.1858 1.23835C13.9433 1.39551 13.7515 1.61949 13.6335 1.88326L9.93304 10.0748L1.38154 10.7543C1.09422 10.777 0.819546 10.8821 0.590372 11.0569C0.361197 11.2316 0.187229 11.4687 0.0892791 11.7398C-0.00867057 12.0109 -0.0264539 12.3044 0.0380568 12.5853C0.102568 12.8662 0.246641 13.1226 0.45304 13.3238L6.77404 19.4843Z",
    fill: "url(#paint0_linear_284_1056)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_284_1056",
    x1: -3.96065,
    y1: 5.55201,
    x2: 32.3395,
    y2: 9.8905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEE5"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStarFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star-fill.d728100408a95fd0607937b8df6deba4.svg";